import AcademicTermRange from "./AcademicTermRange";

class AcademicTerm {
    id: number;
    year: number;
    ranges: AcademicTermRange[];

    get display() {
        const start = this.ranges.first().startDate;
        const end = this.ranges.last().endDate;
        return start.getFullYear() === end.getFullYear()
            ? `${start.getFullYear()}`
            : `${start.getFullYear()}/${end.getFullYear()}`;
    }

    get startDate() {
        return this.ranges.first().startDate;
    }

    get endDate() {
        return this.ranges.last().endDate;
    }

    constructor(data?: Partial<AcademicTerm>) {
        Object.assign(this, data);

        this.ranges = this.ranges?.map(r => new AcademicTermRange(r)) || [];
    }

    replaceRange(updated: AcademicTermRange) {
        const rangeIndex = this.ranges.findIndex(r => r.id === updated.id);
        if (rangeIndex !== -1) {
            this.ranges[rangeIndex] = new AcademicTermRange(updated);
        } else {
            this.ranges.forEach(r => r.replaceRange(updated));
        }
        this.validateRanges();
    }

    validateRanges() {
        let last: AcademicTermRange = null;
        for (const child of this.ranges) {
            if (child.children.length)
                for (const grandChild of child.children) {
                    grandChild.error = false;
                    if (last && last.endDate.moreDate(grandChild.startDate))
                        grandChild.error = true;
                    last = grandChild;
                }
            else {
                child.error = false;
                if (last && last.endDate.moreDate(child.startDate))
                    child.error = true;
                last = child;
            }
        }
    }

    hasError() {
        return this.ranges.some(r => r.hasError());
    }
}

export default AcademicTerm;
